import apis from "@/apis";
import * as _ from "lodash";
import axios from "axios";
import lambda from "@/apis/lambda";
import store from "../store";
import * as jspdf from "jspdf";

export default {
    onFileChange(files, filename) {
        return new Promise((resolve, reject) => {
            //var files = e.target.files || e.dataTransfer.files;
            var objReturn = {
                status: false,
                message: ""
            }

            if (!files.length) {
                objReturn.message = "No Files Found";
                resolve(objReturn);
            }

            var strings;
            //if (Array.isArray(files)) {
            if (files.name == undefined) {
                strings = files[0].name.split(".");
            } else {
                strings = files.name.split(".");
            }

            if (strings.length > 0) {
                var extn = strings[strings.length - 1].toLowerCase();


                if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
                    objReturn.status = false;
                    objReturn.message = "Wrong File Input";

                    resolve(objReturn);
                }
                var userinfo = store.getters.loggedUser;
                var userid = userinfo.UserId;
                var filetype = files[0].type;
                var filepath = filename + extn;
               

                var filepath = userid+"!!~~!!"+filepath;
                let data = new FormData();
                let file = files[0];
                  data.append('file', file,filepath);
              let config = {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  "Access-Control-Allow-Origin": "*",
                   "Authorization": "Bearer " + store.getters.authToken,
                }
              }
               
              axios.post('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
            //   axios.post('http://localhost:51169/api/LoanDisbursement/UploadSactionLetter', data, config)
                    .then(res => {
                        if (res.status == 200) {
                            objReturn.status = true;
                            objReturn.message = filename + extn;
                            resolve(objReturn);
                        }
                    })
                    .catch(err => {
                        objReturn.status = false;
                        objReturn.message = err.message;
                        resolve(objReturn);
                    });
            }
        });
    },

    getImgUrl(pic) {
        if (pic) {
            if (pic.split(".").pop() == "pdf") {
                return require("@/assets/Pdf.jpg");
            }

            var userinfo = store.getters.loggedUser;
            var userid = userinfo.UserId;
            return (
                "https://aws.msobcfdc.in/S3BucketApril/" +
                userid.toLowerCase() +
                "/" +
                pic
            );
        }
    },
    getImgUrl2(pic) {
        if (pic) {
            var userinfo = store.getters.loggedUser;
            var userid = userinfo.UserId;
            return (
               // "https://aws.msobcfdc.in/S3BucketApril/" +
               "https://aws.msobcfdc.in/S3BucketApril/" +
                userid.toLowerCase() +
                "/" +
                pic
            );
        }
    },
}


// WEBPACK FOOTER //
// ./src/apis/common.js